// extracted by mini-css-extract-plugin
module.exports = {"container":"LogoAndRights_container__IPqXM","logo-wrap":"LogoAndRights_logo-wrap__dyY4p","rights":"LogoAndRights_rights__1JM6j"};